// export const baseUrl = "http://192.168.10.24:8002";
export const baseUrl = "https://api.royalhair.ir";
